// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentListedModalEdit_modal_container__n1PO\\+ .ant-modal-content {
    width: 100%;
    height: 820px;
    border-radius: 20px;
}

.ComponentListedModalEdit_modal_container__n1PO\\+ .ant-modal-body {
    width: 100%;
    height: 95%;
}

.ComponentListedModalEdit_modal_container__n1PO\\+ .ComponentListedModalEdit_footer__r6Xz5 .ant-form-item {
    margin-bottom: 0;
}

.ComponentListedModalEdit_left_content__2qRCz .ant-form-item {
    margin-bottom: 10px;
}

.ComponentListedModalEdit_main__iJHHO {
    display: flex;
    width: 100%;
    height: calc(100% - 40px);
}

.ComponentListedModalEdit_main_left__BUHwC,
.ComponentListedModalEdit_main_right__ETlAP {
    width: 50%;
    height: 100%;
    padding: 0 20px;
    border: 1px solid #ccc;
}

.ComponentListedModalEdit_left_header__4q4Bi,
.ComponentListedModalEdit_right_header__NnwVV {
    width: 100%;
    height: 30px;
    margin-bottom: 10px;
    font-size: 20px;
    text-align: center;
}

.ComponentListedModalEdit_footer__r6Xz5 {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 40px;
}

.ComponentListedModalEdit_left_header__4q4Bi {

}

.ComponentListedModalEdit_right_header__NnwVV {

}

/* 前台信息 */
.ComponentListedModalEdit_right_header_img_box__\\+jbF9 {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.ComponentListedModalEdit_right_header_img__ltJFE {
    width: 55px;
    height: 55px;
    border: 1px solid #ccc;
    border-radius: 6px;
}

.ComponentListedModalEdit_right_header_butn__YuIsm {
    margin-right: 10px;
}

.ComponentListedModalEdit_right_header_text_box__OM0C3 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 5px 0;
    width: 60%;
}

.ComponentListedModalEdit_name_input__RVljE {
    width: 60%;
}

.ComponentListedModalEdit_right_header_text__GQMzc {
    margin-bottom: 10px;
}

.ComponentListedModalEdit_introduce_box__oINc6,
.ComponentListedModalEdit_example_box__YqezJ {
    width: 100%;
    height: 150px;
    padding: 10px 0;
}

.ComponentListedModalEdit_introduce_title__LX51R,
.ComponentListedModalEdit_example_title__PerSK {
    padding: 0 0 5px 10px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
    text-align: left;
}

.ComponentListedModalEdit_introduce_text__g4ISk,
.ComponentListedModalEdit_example_text__h7Wyb {
    width: 100%;
    padding: 10px;
    border: 1px solid #D9D9D9;
    background-color: #f9f9f9;
    border-radius: 12px;
    font-size: 12px;
    color: #414648;
}

.ComponentListedModalEdit_change_avatar__ncQV7 {
    position: absolute;
    top: -16px;
    right: -16px;
    cursor: pointer;
}

.ComponentListedModalEdit_custom_textarea__3rFhc {
    background-color: #f9f9f9;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ComponentListedModalEdit/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA,SAAS;AACT;IACI,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".modal_container :global(.ant-modal-content) {\n    width: 100%;\n    height: 820px;\n    border-radius: 20px;\n}\n\n.modal_container :global(.ant-modal-body) {\n    width: 100%;\n    height: 95%;\n}\n\n.modal_container .footer :global(.ant-form-item) {\n    margin-bottom: 0;\n}\n\n.left_content :global(.ant-form-item) {\n    margin-bottom: 10px;\n}\n\n.main {\n    display: flex;\n    width: 100%;\n    height: calc(100% - 40px);\n}\n\n.main_left,\n.main_right {\n    width: 50%;\n    height: 100%;\n    padding: 0 20px;\n    border: 1px solid #ccc;\n}\n\n.left_header,\n.right_header {\n    width: 100%;\n    height: 30px;\n    margin-bottom: 10px;\n    font-size: 20px;\n    text-align: center;\n}\n\n.footer {\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    width: 100%;\n    height: 40px;\n}\n\n.left_header {\n\n}\n\n.right_header {\n\n}\n\n/* 前台信息 */\n.right_header_img_box {\n    position: relative;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.right_header_img {\n    width: 55px;\n    height: 55px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n}\n\n.right_header_butn {\n    margin-right: 10px;\n}\n\n.right_header_text_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 5px 0;\n    width: 60%;\n}\n\n.name_input {\n    width: 60%;\n}\n\n.right_header_text {\n    margin-bottom: 10px;\n}\n\n.introduce_box,\n.example_box {\n    width: 100%;\n    height: 150px;\n    padding: 10px 0;\n}\n\n.introduce_title,\n.example_title {\n    padding: 0 0 5px 10px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n    text-align: left;\n}\n\n.introduce_text,\n.example_text {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #D9D9D9;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n    font-size: 12px;\n    color: #414648;\n}\n\n.change_avatar {\n    position: absolute;\n    top: -16px;\n    right: -16px;\n    cursor: pointer;\n}\n\n.custom_textarea {\n    background-color: #f9f9f9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_container": `ComponentListedModalEdit_modal_container__n1PO+`,
	"footer": `ComponentListedModalEdit_footer__r6Xz5`,
	"left_content": `ComponentListedModalEdit_left_content__2qRCz`,
	"main": `ComponentListedModalEdit_main__iJHHO`,
	"main_left": `ComponentListedModalEdit_main_left__BUHwC`,
	"main_right": `ComponentListedModalEdit_main_right__ETlAP`,
	"left_header": `ComponentListedModalEdit_left_header__4q4Bi`,
	"right_header": `ComponentListedModalEdit_right_header__NnwVV`,
	"right_header_img_box": `ComponentListedModalEdit_right_header_img_box__+jbF9`,
	"right_header_img": `ComponentListedModalEdit_right_header_img__ltJFE`,
	"right_header_butn": `ComponentListedModalEdit_right_header_butn__YuIsm`,
	"right_header_text_box": `ComponentListedModalEdit_right_header_text_box__OM0C3`,
	"name_input": `ComponentListedModalEdit_name_input__RVljE`,
	"right_header_text": `ComponentListedModalEdit_right_header_text__GQMzc`,
	"introduce_box": `ComponentListedModalEdit_introduce_box__oINc6`,
	"example_box": `ComponentListedModalEdit_example_box__YqezJ`,
	"introduce_title": `ComponentListedModalEdit_introduce_title__LX51R`,
	"example_title": `ComponentListedModalEdit_example_title__PerSK`,
	"introduce_text": `ComponentListedModalEdit_introduce_text__g4ISk`,
	"example_text": `ComponentListedModalEdit_example_text__h7Wyb`,
	"change_avatar": `ComponentListedModalEdit_change_avatar__ncQV7`,
	"custom_textarea": `ComponentListedModalEdit_custom_textarea__3rFhc`
};
export default ___CSS_LOADER_EXPORT___;
